import request from '@/utils/request'

// 获取某节的题目列表
export function getQuestionList(sectionId, mode) {
  return request({
    url: '/front/question/list/' + sectionId,
    method: 'get',
    params: { mode }
  })
}

// 提交答题记录
export function submitAnswer(data) {
  return request({
    url: '/front/question/submit',
    method: 'post',
    data
  })
}

// 切换收藏状态
export function toggleFavorite(questionId) {
  return request({
    url: '/front/question/favorite/toggle',
    method: 'post',
    data: { questionId }
  })
}

// 批量检查收藏状态
export function checkFavorites(questionIds) {
  return request({
    url: '/front/question/favorite/check',
    method: 'post',
    data: { questionIds }
  })
}

// 获取收藏列表（分页）
export function getFavoriteList(pageNum = 1, pageSize = 10) {
  return request({
    url: '/front/question/favorite/list',
    method: 'get',
    params: { pageNum, pageSize }
  })
}

// 获取单个题目详情
export function getQuestionDetail(questionId) {
  return request({
    url: '/front/question/detail/' + questionId,
    method: 'get'
  })
}

// 重置某节的做题记录
export function resetSectionRecord(sectionId) {
  return request({
    url: '/front/question/reset/' + sectionId,
    method: 'post'
  })
}

// 校验答案（不保存记录）
export function checkAnswer(data) {
  return request({
    url: '/front/question/check',
    method: 'post',
    data
  })
}
